import { memo } from 'react'
import { imageUrl } from '../../../lib/uploads'
import { ProgressiveImage } from '../ProgressiveImage'

type ThumbnailShape = 'square' | 'round' | 'wide'

// Rendered size per shape; width/height attributes reserve the space before the image loads
const SIZES: Record<ThumbnailShape, { width: number; height: number }> = {
  square: { width: 40, height: 40 },
  round: { width: 40, height: 40 },
  wide: { width: 80, height: 40 },
}

interface ThumbnailProps {
  // Stored image path (e.g. /uploads/images/<uuid>.png); nothing renders an image without it
  path: string | null | undefined
  // The record's image_low_res, shown while the full image loads
  lowResPath?: string | null
  alt: string
  shape?: ThumbnailShape
}

export const Thumbnail = memo(({ path, lowResPath, alt, shape = 'square' }: ThumbnailProps) => {
  if (!path) {
    return (
      <span className="thumbnail thumbnail--empty" aria-hidden="true">
        —
      </span>
    )
  }
  const { width, height } = SIZES[shape]
  return (
    <ProgressiveImage
      className={`thumbnail thumbnail--${shape}`}
      src={imageUrl(path)}
      lowResSrc={lowResPath ? imageUrl(lowResPath) : null}
      alt={alt}
      width={width}
      height={height}
    />
  )
})

Thumbnail.displayName = 'Thumbnail'
